import { tr } from 'i18n';
import moment from 'moment';
import { parseDateToMoment } from './parseDate';

/**
 * Форматирует длительность между двумя моментами времени
 * @param {moment.Moment|string} start - начало (Moment или строка 'DD.MM.YYYY HH:mm')
 * @param {moment.Moment|string} end   - конец  (Moment или строка 'DD.MM.YYYY HH:mm')
 * @returns {string} — "2 д 3 ч 15 мин" или "45 сек"
 */
export const formatDuration = (start, end) => {
  const s = moment.isMoment(start) ? start : parseDateToMoment(start);
  const e = moment.isMoment(end) ? end : parseDateToMoment(end);
  if (!s?.isValid() || !e?.isValid() || e.isBefore(s)) return '';

  const diff = moment.duration(e.diff(s));
  const days = Math.floor(diff.asDays());
  const hours = diff.hours();
  const minutes = diff.minutes();
  const seconds = diff.seconds();

  let result = '';
  if (days > 0) result += tr("{{value0}} д ", { value0: days });
  if (hours > 0) result += tr("{{value0}} ч ", { value0: hours });
  if (minutes > 0) {
    result += tr("{{value0}} мин", { value0: minutes });
  } else if (days === 0 && hours === 0) {
    result += tr("{{value0}} сек", { value0: seconds });
  }
  return result.trim() || tr("0 сек");
};
